import {addItem} from '@shopify/theme-cart';

/**
 * Sequential resolution of promises
 */
export default async function addToCartInSequence(items: addItem[]): Promise<any[]> {
  const results = [];
  let response;

  for (const item of items) {
    try {
      response = await addItem(item.id, item.options);
    } catch (error) {
      response = error;
    }

    results.push(response);
  }

  return results;
}
